import api from "../../index";

// Create a mobile-copilot-chat-category
export const createMobileCopilotChatCategory = async (values: any) => {
  return await api.post("/mobile-copilot-chat-category", values);
};

// Get all mobile-copilot-chat-categories
export const getAllCategories = async () => {
  return await api.get(`/mobile-copilot-chat-categories`);
};

// Get a category by id
export const getMobileCopilotChatCategoryById = async (id: any) => {
  return await api.get(`/mobile-copilot-chat-category/${id}`);
};

// Update a mobile-copilot-chat-category by id
export const updateMobileCopilotChatCategoryById = async (
  id: any,
  values: any
) => {
  return await api.put(`/mobile-copilot-chat-category/${id}`, values);
};

// Delete a mobile-copilot-chat-category by id
export const deleteMobileCopilotChatCategoryById = async (id: any) => {
  return await api.delete(`/mobile-copilot-chat-category/${id}`);
};
